import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Spinner from '../Spinner';
import Button from '../Button';
import AngleRightIcon from '../../icons/AngleRightIcon';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const BoxedArrowLink = ({ children, className, onClick, ...props }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async event => {
    event.preventDefault();
    setLoading(true);
    await onClick();
    setLoading(false);
  };

  const classes = classNames({
    'boxed-arrow-link': true,
    disabled: loading,
    [className]: !!className,
  });

  return (
    <Button
      btnStyle="link"
      className={classes}
      onClick={handleClick}
      {...props}
    >
      {children}
      <span className="end-icon">
        {!loading && <AngleRightIcon width="11" height="22" color="#0D84FE" />}
        {loading && <Spinner size="xs" />}
      </span>
    </Button>
  );
};

BoxedArrowLink.propTypes = propTypes;

export default BoxedArrowLink;
